import React from 'react';

const Banner = ({ title, description, customHeight = false, textBlack = false }) => {
  return (
    <section className={`section banner-bg ${customHeight ? 'custom-height' : ''}`}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-12 mx-auto text-center">
            <h1 className={`top-heading ${textBlack ? 'text-black' : ''}`} dangerouslySetInnerHTML={{ __html: title }} />
            {description && <p className="lead" dangerouslySetInnerHTML={{ __html: description }} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;